
@if (showHeading) {
  <h3 class="text-uppercase fw-bold h5" data-test-id="app-auto-vision-condition-disclosures-e-header">{{autoVisionConditionDisclousuresTranslations.conditionAndDisclosures}}</h3>
}

@if (state$ | async; as state) {
  <app-vehicle-condition-disclosures
    [showDamageShading]="state.showDamageShading"
    [showInspection]="state.showInspection"
    [hasRedLight]="state.hasRedLight"
    [hasYellowLight]="state.hasYellowLight"
    [yellowLightLabel]="state.yellowLightLabel"
    [tireCondition]="translateTireCondition(state.tireCondition)"
    [config]="state.config"
    [damageData]="state.damageData"
    [inspection]="state.inspection"
    [formatItems]="formatItems"
    [operableFlag]="state.operableFlag"
    [disclosureComment]="state.disclosureComment"
    [variant]="showHeading ? 'card' : 'sliders'"
    [legalStatements]="translateLegalStatements(state.legalStatements)"
    [damageType]="state.damageType"
    [damageAmount]="state.damageAmount"
    [vehicleCondition]="autoVisionConditionDisclousuresTranslations.vehicleConditiontransData"
    [conditionIndicatorTranslations]="autoVisionConditionDisclousuresTranslations.conditionIndicatorTranslations"
    [isBulleted]=true
    [bulletedToolTipContentToolTipOverCount]=true
    [hideDisclosureCount]=true
  ></app-vehicle-condition-disclosures>
}
